import { Component, model, signal, inject } from '@angular/core';
import { ImageModel } from '../../shared/models/image.model';
import { User } from '../../shared/models/user.model';
import { ActivatedRoute } from '@angular/router';
import { ProfileService } from '../../profile/services/profile.service';
import { RoutesService } from '../../shared/services/routes.service';
import { ButtonModule } from 'primeng/button';
import { ImagesService } from '../services/images.service';
import { ImagesFormComponent } from "../images-form/images-form.component";
import { AccessService } from '../../core/services/access.service';
import { Image } from '../models/image.model';

@Component({
  selector: 'app-image-delete',
  standalone: true,
  imports: [ButtonModule, ImagesFormComponent],
  templateUrl: './image-delete.component.html',
  styleUrl: './image-delete.component.css'
})
export class ImageDeleteComponent {
  routesService = inject(RoutesService)
  access = inject(AccessService).access
  imageId!: string | null;

  image = model<Image | undefined>(undefined)
  error = model<any>(undefined)

  profile = signal<User | undefined>(undefined)

  constructor(
    private route: ActivatedRoute,
    private imagesService: ImagesService,
    private profileService: ProfileService,
  ) {}
  ngOnInit(): void {
    this.profileService.validateProfile()
    this.imagesService.title.update((value) => 'Imagen Eliminada')
    this.route.paramMap.subscribe(params => {
      this.imageId = params.get('id');
      this.getImage(params.get('id'));
    });
  }

  getImage(imageId: string | null) {
    console.log('getImage', imageId)
    if (imageId === null) {
      this.image.update((value) => (value = undefined));
    } else {
      this.imagesService.delete(imageId).subscribe(res => {
        console.log('Image deleted successfully: ', res);
        this.image.update(value => (value = Image.from(res)));
      }, error => {
        console.log('Error deleting Image: ', error);
        this.error.update(value => (value = error));
      });
    }
  }
}
